module.exports = __webpack_public_path__ + "705d9e1484cb049a39868430263cde94.svg";